var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0076 31.7116C15.6147 32.0961 16.3853 32.0961 16.9924 31.7116C25.7104 26.1888 31.6058 16.547 31.9988 5.4904C32.0244 4.76972 31.6409 4.09826 31.0096 3.75983C26.5322 1.35975 21.4234 9.82717e-07 16 5.08584e-07C10.5766 3.44517e-08 5.46785 1.35975 0.990428 3.75982C0.359068 4.09826 -0.0244063 4.76972 0.00121224 5.4904C0.394251 16.547 6.28962 26.1888 15.0076 31.7116Z",
    fill: "#986CE0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0076 31.7116C15.6147 32.0961 16.3853 32.0961 16.9924 31.7116C25.7104 26.1888 31.6058 16.547 31.9988 5.4904C32.0244 4.76972 31.6409 4.09826 31.0096 3.75983C26.5322 1.35975 21.4234 9.82717e-07 16 5.08584e-07C10.5766 3.44517e-08 5.46785 1.35975 0.990428 3.75982C0.359068 4.09826 -0.0244063 4.76972 0.00121224 5.4904C0.394251 16.547 6.28962 26.1888 15.0076 31.7116Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.18,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.93172,
    y1: 32,
    x2: 7.42741,
    y2: 0.000135259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.d1cd26509dfea1d9029df0ba3283705a.svg";
export { ForwardRef as ReactComponent };